/**
 * Central API configuration. Use for all backend requests.
 * Set REACT_APP_API_URL in .env (e.g. http://localhost:8000 for dev). See .env.example.
 */
import { getAccessToken } from "./authStore";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export function getApiHeaders() {
  const headers = { "Content-Type": "application/json" };
  const token = getAccessToken();
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return headers;
}

/**
 * Public Cloudflare Turnstile site key (REACT_APP_TURNSTILE_SITE_KEY, set at build
 * time). Empty when it is not configured; the contact form then refuses to send
 * instead of skipping the check (SEC-5). Read on each call so tests can set it.
 */
export function getTurnstileSiteKey() {
  return (process.env.REACT_APP_TURNSTILE_SITE_KEY || "").trim();
}

/** For multipart/form-data (no Content-Type; browser sets boundary). */
export function getApiHeadersMultipart() {
  const headers = {};
  const token = getAccessToken();
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return headers;
}

export { API_BASE_URL };
export default API_BASE_URL;
